module.exports = __webpack_public_path__ + "img/reset-password-v2-dark.b6b31ced.svg";